import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  modifiedKeyCondition: null,
  selectedUser: null,
  editingConditionId: null,
  isSpecialConditionChecked: false,
  specialConditionNode: null,
  action: null,
};

const KeyConditionSlice = createSlice({
  name: "key-conditions",
  initialState,
  reducers: {
    setModifiedKeyCondition(state, action) {
      const modifiedKeyCondition = action.payload;
      state.modifiedKeyCondition = modifiedKeyCondition;
    },
    setSpecialConditionNode(state, action) {
      const specialConditionNode = action.payload;
      state.specialConditionNode = specialConditionNode;
    },
    setSelectedUser(state, action) {
      const selectedUserDetails = action.payload;
      state.selectedUser = selectedUserDetails;
    },
    setConditionParams(state, action) {
      const { editingConditionId, conditionAction } = action.payload;
      state.editingConditionId = editingConditionId;
      state.action = conditionAction;
    },
    resetModifiedKeyCondition(state) {
      state.modifiedKeyCondition = null;
    },
    resetSelectedUser(state) {
      state.selectedUser = null;
    },
    resetLinkParams(state) {
      state.editingConditionId = null;
      state.action = null;
    },
    setIsSpecialConditionChecked(state, action) {
      state.isSpecialConditionChecked = action.payload;
    },
    resetSpecialConditionChecked(state) {
      state.isSpecialConditionChecked = false;
      state.specialConditionNode = null;
    },
    setSpecialConditionReason(state, action) {
      state.specialConditionNode.reason = action.payload;
    },
  },
});

export const KeyConditionAction = {
  ADD: "add",
  EDIT: "edit",
  DELETE: "delete",
};

const {
  setModifiedKeyCondition,
  setSelectedUser,
  resetModifiedKeyCondition,
  resetSelectedUser,
  setConditionParams,
  resetLinkParams,
  setIsSpecialConditionChecked,
  resetSpecialConditionChecked,
  setSpecialConditionNode,
  setSpecialConditionReason,
} = KeyConditionSlice.actions;

export const KeyConditionActions = {
  setModifiedKeyCondition,
  setSelectedUser,
  resetModifiedKeyCondition,
  resetSelectedUser,
  setConditionParams,
  resetLinkParams,
  setIsSpecialConditionChecked,
  resetSpecialConditionChecked,
  setSpecialConditionNode,
  setSpecialConditionReason,
};

export const KeyConditionReducer = KeyConditionSlice.reducer;
